import { Typography } from '@mui/material';

const EnvDisabledContent = () => (
	<Typography>
		Apologies for the inconvenience: mid-term adjustments are currently unavailable. We are working diligently to
		restore this feature.
	</Typography>
);

export default EnvDisabledContent;
